import styled from "styled-components";

export const Sidebar = styled("div")`
  display: flex;
  flex-direction: column;
  width: 310px;
`;

export const SidebarTitle = styled("div")`
  height: 46px;
  margin: 0 0 9px;
  font-size: 21px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: normal;
  text-align: center;
  color: #2e3d49;
`;

export const SidebarMoreInfo = styled("div")`
  height: 15px;
  margin-bottom: 9px;
  font-family: Manrope;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2e3d49;
`;

export const SidebarSupp = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: start;
  flex: 3;
  padding: 15px;
  border-radius: 3px;
  border: solid 1px #e4e4e4;
  background-color: #ffffff;
`;

export const SupText = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: bold;
`;

export const PolygonComparison = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PolygonComparisonDates = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;
  height: 44px;
`;
